<template>
  <div style="width: 100%;height: 100%;" class="body3">
    <div class="all">
      <div class="main">
        <div class="top_bg2">
          <headers pageType="applyIndex"></headers>
          <div class="position2">
            <div class="wraper"><p><a href="javascript:void(0)" style="color:#888888" @click="urlTo('home')">首页</a> /<a href="javascript:void(0)" style="color:#888888" @click="urlTo('applyIndex')"> 个人办事</a> / <span style="color:#2e2e2e">{{nav_name}}</span></p></div>
          </div>
        </div>
        <div class="fixed">
          <fixedDiv></fixedDiv>
        </div>

        <div class="wraper">
          <div class="advice" >
            <h2 class="tit8 line_bottom"><span><img src="../../../static/images/guide_sign8.png">{{nav_name}}</span><em><img src="../../../static/images/required.png">为必填项</em></h2>
            <dl class="advice_tips" style="color: red">
              <dt>温馨提示</dt>
              <dd>   1、此工具根据相关政策文件进行的粗略测算，测算金额不是实际办理结果。</dd>


            </dl>
            <el-form   :rules="rules" :model="ruleForm" label-width="100px" ref="ruleForm" class="demo-ruleForm">
              <table width="90%" border="0" cellspacing="0" cellpadding="0" class="advice_tab">
                <tr >
                  <td style="width: 202px;">
                    <el-form-item  label="受理单位" prop="selectedRegions">
                      <el-cascader v-model="selectedRegion" :props="props" :show-all-levels="false"   @change="onSelectedRegion" placeholder="请选择受理单位" clearable style="width: 200px;"></el-cascader>
                    </el-form-item>
                  </td>
                  <el-form-item  label="供养方式：" prop="ORPTypeCode">
                    <el-select
                      v-model="ruleForm.ORPTypeCode"
                      collapse-tags
                      placeholder="请选择" style="width: 250px;">
                      <el-option
                        v-for="item in ORPType"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id" >
                      </el-option>
                    </el-select>
                  </el-form-item>

                </tr>



                <tr>
                  <td colspan="3"  >
                    <el-button :loading="loading" type="primary" @click="search" style=" width: 120px;
    margin-left: 100px;" :disabled="disableds">计算</el-button>

                  </td>
                </tr>

              </table>
            </el-form>
            <div v-if="totalShow" style="color: red;font-weight: 600;padding-left: 8%;padding-right: 8%;padding-top: 20px">
              预估你可以领取的孤儿生活费为：{{total.amount}}元/月，具体以实际办理结果为准。
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="clear"></div>
    <footers></footers>

  </div>
</template>

<script>
  import headers from "../../components/Headers";
  import fixedDiv from "../../components/FixedDiv";
  import footers from "../../components/Footer";

  export default {
    name: "suggests",
    components:{
      headers,fixedDiv,footers
    },

    data() {
      let _self=this;
      return {
        disableds:false,
        totalShow:false,
        loading:false,
        selectedRegion:[],

        ORPType:[
          {id:'1',name:'分散供养'},
          {id:'0',name:'集中供养'},
        ],
        ruleForm:{
          // selecteddepartOption:[],
          theTitle:'',
          types:'',
          ORPTypeCode:'',
          textarea:'',
          age:'',
          phone:'',
          verifyCode:'',
          smsCode:'',
        },
        rules:{
          selectedRegions:[{required:true,validator:this.checkDepartId,tigger:'blur'}],
          age:[{required:true ,validator:this.checkAge,tigger:'blur'}],
          ORPTypeCode:[{required:true ,message:'请选择供养方式',tigger:'change'}],

        },



        props: {
          lazy: true,
          checkStrictly:props,
          lazyLoad (node, resolve) { const { level } = node;
            var t=0;
            if(!node.value){
              node.value=_self.$cookies.get("areaRoot");
              t=1;
              //上级为空，默认设置大通县数据
            }
            const options={pid:node.value}
            _self.$https.post("api/pu/getAreaByParentCode.do",options,response=>{
              const nodes =[];
              // if(t==0) {
              //   if(node.value=='63010001'){
              //     const nodes =[{label:'大通县',value:'6301210001',level:0, leaf: level >= 3}];
              //     resolve(nodes);
              //   }else{
              if (response.status === 200 && response.data.code === 200) {
                const nodes = Object.values(response.data.data).map(function (e) {
                  return {label: e.name, value: e.code, level: 0, leaf: level >= 3}
                })
                resolve(nodes);
              } else {
                resolve(nodes);
              }
              //   }
              // }else{
              //   // const nodes =[{label:'大通县',value:'6301210001',level:0, leaf: level >= 2}];
              //   // resolve(nodes);
              //   const nodes =[{label:'西宁市',value:'63010001',level:0, leaf: level >= 2}];
              //   resolve(nodes);
              // }
            })
          }
        },

      }
    } ,

    watch: {
      width(n, o) {
        alert(n + 'w')
      },
      height(n, o) {
        alert(n + 'h')
      },
      'ruleForm.ORPTypeCode'(n,o){
        console.log(n)
      },
    },
    created(){
      // this.showClause=true;
      // this.initClause();
      //建议类别枚举
      this.service_code=this.$route.query.service_code;
      this.nav_name=this.$route.query.nav_name;



    },
    methods: {

      onSelectedRegion(v){
        if(this.selectedRegion && this.selectedRegion.length>0){
          this.partyId=this.selectedRegion[this.selectedRegion.length-1];
        }else{
          this.partyId="";
        }

      },


      search(){
        this.$refs['ruleForm'].validate((valid) => {
          if (valid) {
            const options = {
              support_statu:this.ORPTypeCode,
              archive_type:'ORP',
              part_id:this.partyId
            }
            this.totalShow = false;
            this.loading=true;
            this.$https.post("api/select/selectPaymentAmount.do", options, response => {
              if (response.status === 200 && response.data.code === 200) {
                this.totalShow = true;
                this.total = response.data.data;
              }
              this.loading=false;
            })
          }else {
            this.totalShow = false;
            this.loading=false;
            return
          }
        })
      },
      countDown(times){
        var time;
        if(times){
          time=times;
        }else{
          time=this.$cookies.get("time2")
          if(!time){
            this.smsIsDisabled=false;
            return;
          }
        }
        time=time-1;
        this.$cookies.set("time2",time,time+"s")
        if(time<=0){
          this.smsIsDisabled=false;
          this.smsText="发送短信";
          this.$cookies.remove("time2")
          return
        }else{
          this.smsText=time+"秒"
          var t=this;
          setTimeout(function() {
            t.countDown(time);
          },1000)
        }

      },

      urlTo(url, params) {
        this.$router.push({path: url, query: params || {}});
      },

      checkAge(rule, value, callback) {

        if (value<70) {
          return callback(new Error('请输入大于70的年龄！'))
        } else{
          callback()
        }
      },
      checkDepartId(rule,value,callback){
        if(!this.selectedRegion || this.selectedRegion.length<=0){
          return callback(new Error('请选择受理单位！'))
        }
        return  callback()
      },



    }
  }



</script>
<style>
</style>



// WEBPACK FOOTER //
// src/pages/calculate/ORPCalculation.vue